import { mutatorAction } from 'satcheljs';
import type ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import type ConversationReadingPaneViewState from 'owa-mail-reading-pane-store/lib/store/schema/ConversationReadingPaneViewState';

export const setItemPartInConversationViewStateMutator: (
    conversationViewState: ConversationReadingPaneViewState,
    nodeId: string,
    itemPartViewState: ItemPartViewState
) => void = mutatorAction(
    'setItemPartInConversationViewStateMutator',
    (
        conversationViewState: ConversationReadingPaneViewState,
        nodeId: string,
        itemPartViewState: ItemPartViewState
    ): void => {
        const itemPartsMap = conversationViewState.itemPartsMap;
        if (itemPartsMap) {
            itemPartsMap.set(nodeId, itemPartViewState);
        } else {
            conversationViewState.itemPartsMap = new Map<string, ItemPartViewState>();
            conversationViewState.itemPartsMap.set(nodeId, itemPartViewState);
        }
    }
);
